import React, { useState } from 'react';
import { parse } from 'json2csv';
const { Parser, transforms: { unwind, flatten } } = require('json2csv');

const JsonToCsvConverter: React.FC = () => {
    const [csvData, setCsvData] = useState<string | null>(null);
    const json2csvParser = new Parser({ transforms: [flatten()] });

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files && e.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                try {
                    const json = JSON.parse(event.target!.result as string);
                    // @ts-ignore
                    const csv = json2csvParser.parse(json);
                    setCsvData(csv);
                } catch (err) {
                    console.error("Error parsing JSON or converting to CSV:", err);
                    alert("There was an error processing the file.");
                }
            };
            reader.readAsText(file);
        }
    };

    return (
        <div>
            <input type="file" accept=".json" onChange={handleFileChange} />
            {csvData && (
                <div>
                    <a
                        href={`data:text/csv;charset=utf-8,${encodeURIComponent(csvData)}`}
                        download="converted.csv"
                    >
                        Download CSV
                    </a>
                </div>
            )}
        </div>
    );
}

export default JsonToCsvConverter;
